export const values = {
  menu: [
    { subject: 'total', value: '전체', content: '전체' },
    { subject: 'kor', value: '한글(국어)영역', content: '한글(국어)' },
    { subject: 'math', value: '수학영역', content: '수학' },
    { subject: 'eng', value: '영어영역', content: '영어' },
    { subject: 'play', value: '놀이·창의영역', content: '놀이·창의' },
    { subject: 'hanja', value: '한자영역', content: '한자' },
  ],
  images: {
    recommend: 'https://us.wink.co.kr/pc/1.1.0/reference_room/recommend.png',
    downloadButton:
      'https://us.wink.co.kr/pc/1.1.0/reference_room/download_button.png',
    previewButton:
      'https://us.wink.co.kr/pc/1.1.0/reference_room/preview_button.png',
    free: 'https://us.wink.co.kr/pc/1.1.0/reference_room/free.png',
    paid: 'https://us.wink.co.kr/pc/1.1.0/reference_room/paid.png',
  },
};

export default values;
